
<li class="menu-item" :class="{ '--active': isActive }">
  <a class="menu-item__content" :href="to">
    <Icon v-if="icon" class="menu-item__icon" :name="icon" />
    <div class="menu-item__title">
      {{ title }}
    </div>
    <div v-if="isQuestionnaire" class="menu-item__extra">
      <span
        id="js-questionnaire-unread-badge"
        class="clinic-sidebar__list-item-balloon-num clinic-sidebar__list-item-balloon"
        :class="{ 'd-none': unreadCount <= 0 }"
        >{{ unreadCount }}</span
      >
    </div>
  </a>
  <div v-if="!!$slots.items" class="menu-item__submenu">
    <slot name="items" />
  </div>
</li>
